import { authHttp } from '../http'
import * as routes from '../../routes/delivery-transfer.routes'
import { errorHandler } from '../../../util/error.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'

export async function getTransfers(tp_id, pInicial, pFinal) {
  try {
    const response = await authHttp().get(routes.urlGetDeliveryTransfer(tp_id, pInicial, pFinal))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveDeliveryTransfer(transfer) {
  try {
    const response = await authHttp().post(routes.urlPostPutDeliveryTransfer, transfer)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getDeliveriesToBeTransfered(tp_id_origin, transfer_id, pInicial, pFinal) {
  try {
    const response = await authHttp().get(
      routes.urlGetDeliveriesToBeTransfered(tp_id_origin, transfer_id, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getCargasParadasTransferencia(tp_id_origin, { pInicial, pFinal }) {
  try {
    const response = await authHttp().get(
      routes.urlGetCargasParadasTransferencia(tp_id_origin, pInicial, pFinal),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveAssocDeliveryStepWithTransfer(
  tp_id_origin,
  transfer_id,
  associations,
  pInicial,
  pFinal,
) {
  try {
    const response = await authHttp().post(
      routes.urlPostAssocDeliveryStepWithTransfer(tp_id_origin, transfer_id, pInicial, pFinal),
      associations,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getDeliveriesForTransferExport(transfer_ids) {
  try {
    const response = await authHttp().get(routes.urlGetDeliveriesForTransferExport(transfer_ids))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function changeStatusToTransfered(transfer_id) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().put(
      routes.urlPutChangeStatusToTransfered(transfer_id, user_id),
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function changeStatusToCanceled(transfer_id) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().put(routes.urlPutChangeStatusToCanceled(transfer_id, user_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getDeliveriesFromTransfer(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetDeliveriesFromTransfer(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function updateAvailableToTransfer(delivery_id, available_to_transfer, transfer_not_available_reason) {
  try {
    const response = await authHttp().put(routes.urlPutUpdateAvailableToTransfer(delivery_id), {
      available_to_transfer,
      transfer_not_available_reason: transfer_not_available_reason || null,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function receiveDeliveriesFromTransfer(step_ids) {
  try {
    const { id: user_id } = getUsuarioInfo()
    const response = await authHttp().post(
      routes.urlPostReceiveDeliveriesFromTransfer(user_id),
      step_ids,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
